import { MeasurementInput } from '../../MeasurementInput'
import { optionalVehicleNumber } from '../../../lib/vehicleFormContract'
import { Vehicle } from '../../../types/optimization'
import { vehicleCoupling, updateVehicleCoupling } from '../../../lib/vehicleAxleDiagram'
import { LinkIcon } from '@heroicons/react/24/outline'

interface FifthWheelConfigProps {
  vehicle: Vehicle | null | undefined
  onChange: (updatedVehicle: Vehicle) => void
  mode?: 'edit' | 'view'
  isTractor?: boolean
}

const inputCls = 'w-full min-w-0 px-2 py-1.5 text-xs rounded-lg border focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white'

export const FifthWheelConfig = ({ vehicle, onChange, mode = 'edit', isTractor = false }: FifthWheelConfigProps) => {
  const coupling = vehicleCoupling(vehicle, isTractor)
  if (!coupling) {
    return <div className="rounded-xl bg-slate-50 p-4 text-sm text-slate-600 dark:bg-slate-800 dark:text-slate-300">Ce type de véhicule n’admet pas de sellette ou de pivot d’attelage. Les configurations d’attelage existantes sont conservées.</div>
  }
  const { tractor, position, maxLoad } = coupling
  const length = optionalVehicleNumber(vehicle?.dimensions?.length ?? vehicle?.length)
  const type = vehicle?.fifth_wheel?.type
  const typeLabel = type ? ({ standard: 'Standard', low: 'Basse', high: 'Haute' }[type] ?? type) : 'Non renseigné'

  function update(field: 'position' | 'maxLoad', value: number | null) {
    if (mode === 'view' || !vehicle) return
    onChange(updateVehicleCoupling(vehicle, field, value, isTractor))
  }

  return <section data-fifth-wheel-config className="rounded-xl p-2.5 space-y-2 bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700">
    <div className="flex items-center gap-2"><LinkIcon aria-hidden="true" className="w-4 h-4 text-orange-500" /><h3 className="font-semibold text-xs text-slate-900 dark:text-white">{tractor ? 'Sellette du tracteur' : 'Pivot d’attelage · semi-remorque'}</h3></div>
    <div className="grid min-w-0 grid-cols-1 gap-2 sm:grid-cols-2">
      <MeasurementInput label={tractor ? 'Position de la sellette depuis l’avant du châssis' : 'Position du pivot depuis l’avant'} quantity="vehicleLength" storageUnit="mm" value={position} onValueChange={value => update('position', value)} disabled={mode === 'view'} className={inputCls} min={0} max={length != null && length > 0 ? length : undefined} />
      <MeasurementInput label="Charge max" quantity="mass" storageUnit="kg" value={maxLoad} onValueChange={value => update('maxLoad', value)} disabled={mode === 'view'} className={inputCls} min={0} />
    </div>
    {length != null && length > 0 && position != null && <input aria-label={tractor ? 'Déplacer la sellette' : 'Déplacer le pivot'} type="range" min={0} max={length} step={1} value={position} onChange={event => update('position', Number(event.target.value))} disabled={mode === 'view'} className="block h-3 w-full accent-orange-500" />}
    <p className="text-[10px] text-slate-500 dark:text-slate-400">Type du profil (indicatif) : <strong>{typeLabel}</strong></p>
  </section>
}
